import { css } from '@emotion/react';
import { ModalClose, styled } from '@mui/joy';

export const CardHeaderModalClose = styled(ModalClose)(
  () => css`
    .MuiSvgIcon-root {
      --Icon-color: var(--joy-palette-text-tertiary);
    }
  `,
);

CardHeaderModalClose.defaultProps = { variant: 'plain', color: 'primary' };
